import { loadStripe } from "@stripe/stripe-js";

export const redirectToCheckout = async (sessionId) => {
    const stripe = await loadStripe(process.env.REACT_APP_STRIPE_KEY);
    await stripe.redirectToCheckout({ sessionId });
};

export const isStripeEnabled = accountName => process.env.REACT_APP_IS_STRIPE_ENABLED === "true" || accountName === 'test';
